export default __webpack_public_path__ + "static/ether_case-vid-1c11d9473503c02dbe89fb252dd9701c.mp4";